import _ from 'lodash';
import {
  getActionTypes,
  getPickListOptions,
  userListAccordingToRole as userListOptions,
} from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('approvalMatrixManagement')([
  'SET_LOADER',
  'LOAD_APPROVAL_MATRIX',
  'UPSERT_APPROVAL_MATRIX',
  'DELETE_APPROVAL_MATRIX',
  'LOAD_GLOBAL_ATTRIBUTES',
  'LOAD_PICKLISTS',
  'DELETE_AREAS',
  'LOAD_ATTRIBUTES',
  'LOAD_TASK_ATTRIBUTES',
]);

export function loadApprovalMatrices(approvalMatrices) {
  return { type: types.LOAD_APPROVAL_MATRIX, approvalMatrices };
}

export function loadAreas(areaMap) {
  return { type: types.LOAD_PICKLISTS, areaMap };
}

export function loadApprovers(approvers) {
  return { type: types.LOAD_PICKLISTS, approvers };
}

export function loadAttribute(attributeObjectsMap) {
  return { type: types.LOAD_ATTRIBUTES, attributeObjectsMap };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function upsertApprovalMatrix(approvalMatrix) {
  return { type: types.UPSERT_APPROVAL_MATRIX, approvalMatrix };
}

export function deleteApprovalMatrix(approvalMatrix) {
  return { type: types.DELETE_APPROVAL_MATRIX, approvalMatrix };
}

export function deleteAreas(ids) {
  return { type: types.DELETE_AREAS, areaIds: ids };
}

export function loadTaskAttributes(taskAttributes) {
  return { type: types.LOAD_TASK_ATTRIBUTES, taskAttributes };
}

export default function approvalMatrixReducer(
  state = { isLoading: true, approvalMatrices: [], picklists: {}, attributes: {}, taskAttributes: [] },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isLoading: action.loader };
    }
    case types.LOAD_APPROVAL_MATRIX: {
      return { ...state, approvalMatrices: action.approvalMatrices };
    }
    case types.LOAD_PICKLISTS: {
      const { areaMap, approvers } = action;
      const { picklists } = state;
      let clonedPicklist = _.cloneDeep(picklists);
      if (areaMap) {
        const clonedAreas = _.clone(picklists.areas) || {};
        Object.keys(areaMap).forEach((key) => {
          clonedAreas[key] = getPickListOptions(areaMap[key].area);
        });
        clonedPicklist = { ...clonedPicklist, areas: clonedAreas };
      } else if (approvers) {
        const approverOptions = userListOptions(approvers);
        clonedPicklist = { ...clonedPicklist, approvers: approverOptions };
      }
      return { ...state, picklists: clonedPicklist };
    }
    case types.LOAD_ATTRIBUTES: {
      const { attributeObjectsMap } = action;
      const { attributes } = state;
      const clonedAttributes = _.cloneDeep(attributes) || {};
      Object.keys(attributeObjectsMap).forEach((key) => {
        if (attributeObjectsMap[key] && attributeObjectsMap[key].attributes) {
          clonedAttributes[key] = attributeObjectsMap[key].attributes.map((val) => {
            return { key: val.id, text: val.attributeDisplayName, value: val.id, originalObject: val };
          });
        }
      });
      return { ...state, attributes: { ...clonedAttributes } };
    }
    case types.DELETE_APPROVAL_MATRIX: {
      return {
        ...state,
        approvalMatrices: state.approvalMatrices.filter(({ id }) => id !== action.approvalMatrix.id),
      };
    }
    case types.UPSERT_APPROVAL_MATRIX: {
      const { approvalMatrix } = action;
      return {
        ...state,
        approvalMatrices: [...state.approvalMatrices.filter(({ id }) => id !== approvalMatrix.id), approvalMatrix],
        isLoading: false,
      };
    }
    case types.DELETE_AREAS: {
      const { areaIds } = action;
      const { picklists } = state;
      const clonedPicklist = _.cloneDeep(picklists);
      const { areas } = clonedPicklist;
      if (areaIds.length) {
        for (const id of areaIds) {
          delete areas[id];
        }
      }
      return {
        ...state,
        picklists: { ...clonedPicklist, areas },
      };
    }
    case types.LOAD_TASK_ATTRIBUTES: {
      const { taskAttributes } = action;
      return {
        ...state,
        taskAttributes: taskAttributes.map((attribute) => {
          return {
            key: attribute.id,
            text: attribute.attributeDisplayName,
            value: attribute.id,
            originalObject: attribute,
          };
        }),
      };
    }
    default:
      return state;
  }
}
